import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row, FormGroup, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane, Input, Label } from 'reactstrap';
import classnames from 'classnames';
import formSchema from '../Utils/schema.json';
import { RenderField } from '../Utils/renderFields';
import { RenderErrorMessage } from '../Utils/renderErrorMessages';
import { LabelText } from '../Utils/Input';
import 'react-phone-number-input/style.css';
import { tabChange } from "../Utils/SetDefaultRowData";
import CommonButton from '../Utils/CommonButton';
import { useSelector } from 'react-redux';
import { countryOptionss, OperatorOptionsFields, OperatorStatusOptions } from '../OperatorManagement/Constant/Options';
import { fetchCountries } from '../../slices/customer/countries/thunk';
import { fetchStates } from '../../slices/customer/states/thunk';
import { fetchCities } from '../../slices/customer/cities/thunk';
import { MAX_IMG_SIZE } from '../Utils/Constants';
import { ImageUpload } from '../Utils/ImageUpload';
export default function OperatorProviderDetail({
    values, handleChange, handleBlur, isEdit, errors, touched, setFieldTouched, setFieldValue, operatorData, navigate, dispatch, setLoading, profile, setChangePasswordStatus, handleImageUpload, callState, roleName, currentSelectedFile
}) {
    const [stateData, setStatedata] = useState();
    const [cityData, setCityData] = useState()
    const [selectedCountry, setSelectedCountry] = useState()
    const [selectedState, setSelectedState] = useState()
    const [callCity, setCallCity] = useState(false)
    const countries = useSelector(state => state.Countries.countries)
    const countryOptions = countryOptionss(countries?.countries)
    const [isValidFile, setIsValidFile] = useState(true)
    const [imageSrc, setImageSrc] = useState(null);
    const [validateSizeError, setValidateSizeError] = useState(null);
    const [imageOn, setImageOn] = useState(false)

    useEffect(() => {
        if (callState) {
            dispatch(fetchStates(selectedCountry, setCallCity, "isOperator", setStatedata))
        }
    }, [dispatch, isEdit, selectedCountry]);

    useEffect(() => {
        if (callCity) {
            dispatch(fetchCities(selectedCountry, selectedState, "isOperator", setCityData))
        }
    }, [dispatch, selectedCountry, selectedState]);

    useEffect(() => {
        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    }, [imageSrc]);

    const operatorOptions = [
        {
            name: "Domain",
            value: "Operator",
            options: OperatorOptionsFields
        },
        {
            name: "country",
            value: "Operator",
            options: countryOptions
        },
        {
            name: "Status",
            value: "Operator",
            options: OperatorStatusOptions
        }
    ]

    return (
        <div className="live-preview">
            <div>
                {roleName != "systemUser" && formSchema.map((section, sectionIndex) => (
                    <>
                        {section.title === "Operator" && section.sections &&
                            section.sections.map((subSection, subSectionIndex) => (
                                subSection.sectionTitle === "Business Profile" && (
                                    <div key={subSectionIndex} className='mb-4'>
                                        <div>
                                            <Row className="gy-4" key={sectionIndex}>
                                                {subSection.fields.filter(field => {
                                                    if (field.name === "country" && stateData) {
                                                        operatorOptions?.push(stateData)
                                                    }
                                                    if (field.name === "state" && cityData) {
                                                        operatorOptions?.push(cityData)
                                                    }
                                                    if (isEdit && (field.name === "Domain" || field.name === "username" || field.name === "email")) {
                                                        field.disable = true
                                                    } else {
                                                        field.disable = false
                                                    }
                                                    if (field.name === "Status") {
                                                        return false
                                                    }
                                                    return true;
                                                }).map((field, fieldIndex) => (
                                                    <Col
                                                        xxl={field.name === "businessName" ? 12 : field.name === "Domain" ? 4 : field.name === "endDate" ? 4 : field.name === "Address" ? 4 : field.name === "Address2" ? 4 : field.name === "country" ? 4 : field.name === "Address"}
                                                        md={field.name === "businessName" ? 12 : 6}
                                                        lg={field.name === "businessName" ? 12 : 6}
                                                        key={`${subSectionIndex}-${fieldIndex}`}
                                                    >
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={
                                                                "ms-0 rv-form-label"
                                                            }
                                                            className={field.required ? "text-danger" : ""}
                                                            displayText={field.label}
                                                            important={field.required ? "*" : ""}
                                                        />
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] &&
                                                                errors[field.name]
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                                } `}
                                                            displayText={field.placeholder
                                                            }
                                                        />
                                                        <>
                                                            <RenderField
                                                                field={field}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                values={values}
                                                                touched={touched}
                                                                errors={errors}
                                                                setFieldTouched={setFieldTouched}
                                                                setFieldValue={setFieldValue}
                                                                options={operatorOptions}
                                                                setSelectedCountry={setSelectedCountry}
                                                                setSelectedState={setSelectedState}
                                                                isFromBussinessProfileModel={true}
                                                            />
                                                            {/* <RenderErrorMessage
                                                                field={field}
                                                                touched={touched}
                                                                errors={errors}
                                                            /> */}
                                                        </>

                                                    </Col>
                                                ))}
                                                {subSection?.sectionTitle === "Business Profile" && subSection.fieldsOne.filter(field => {
                                                    if (field.name === "country" && stateData) {
                                                        operatorOptions?.push(stateData)
                                                    }
                                                    if (field.name === "state" && cityData) {
                                                        operatorOptions?.push(cityData)
                                                    }
                                                    if (isEdit && (field.name === "Domain" || field.name === "username" || field.name === "email")) {
                                                        field.disable = true
                                                    }
                                                    else {
                                                        field.disable = false
                                                    }
                                                    if (field.name === "Status") {
                                                        return false
                                                    }
                                                    return true
                                                }).map((field, fieldIndex) => (
                                                    <Col
                                                        xxl={4}
                                                        md={6}
                                                        key={`${subSectionIndex}-one-${fieldIndex}`}
                                                    >
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={
                                                                "ms-0 rv-form-label"
                                                            }
                                                            className={field.required ? "text-danger" : ""}
                                                            displayText={field.label}
                                                            important={field.required ? "*" : ""}
                                                        />

                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] &&
                                                                errors[field.name]
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                                } `}
                                                            displayText={field.placeholder
                                                            }
                                                        />
                                                        <RenderField
                                                            field={field}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            values={values}
                                                            touched={touched}
                                                            errors={errors}
                                                            setFieldTouched={setFieldTouched}
                                                            setFieldValue={setFieldValue}
                                                            options={operatorOptions}
                                                            setSelectedCountry={setSelectedCountry}
                                                            setSelectedState={setSelectedState}
                                                            isFromBussinessProfileModel={true}
                                                        />
                                                        {/* <RenderErrorMessage
                                                            field={field}
                                                            touched={touched}
                                                            errors={errors}
                                                        /> */}
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    </div>
                                )
                            ))
                        }

                    </>
                ))}
            </div>
            <ImageUpload
                validateSizeError={validateSizeError}
                profilePicture={imageSrc}
                isProfile={imageOn}
                removeProfilePicture={() => {
                    setImageSrc(null)
                    setIsValidFile(true)
                    setImageSrc(false)
                    setValidateSizeError(null)
                }}
                isFromProfileScreen={true}
                handleImageChange={(event) => {
                    const file = event.target.files[0];
                    const allowedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
                    if (!allowedFormats.includes(file.type)) {
                        setValidateSizeError(
                            "Invalid file format. Please upload JPEG, PNG, or SVG."
                        );
                    }
                    if (file) {
                        const previewUrl = URL.createObjectURL(file);
                        setImageSrc(file);
                        if ((file?.size / (1024 * 1024)) <= MAX_IMG_SIZE) {
                            if (!isValidFile) {
                                setIsValidFile(true)
                            }
                            currentSelectedFile(file)
                            setImageOn(true)
                        }
                        else {
                            setValidateSizeError("File size exceeds the limit (10MB)");
                            setIsValidFile(false)
                            setImageOn(false)
                        }
                    }
                }}
            ></ImageUpload>

            <div class="d-flex justify-content-center gap-2 mt-3">
                <div className="d-flex gap-2">
                    <button
                        type="button"
                        className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                        onClick={() => {
                            navigate('/dashboard')
                        }}
                    >
                        <i class="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                        <span class="px-2 ms-2 me-1 fw-bold">
                            Cancel
                        </span>
                    </button>

                    <button
                        disabled={!isValidFile}
                        type="submit"
                        class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                    >
                        <i class="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                        <span class="px-2 ms-2 me-1 fw-bold">
                            Submit
                        </span>
                    </button>
                </div>

            </div>
            {/* {isEdit && (
                <Col lg={12} className="d-flex justify-content-end mt-3">
                    <CommonButton outline={true} className={"cancel-button-background me-3"} color={"main-color"} type={"reset"} buttonAction={() => navigate('/dashboard')} buttonText={"Cancel"} />
                    <CommonButton color={"main-color"} type={'submit'} buttonText={"Confirm"} />
                </Col>
            )} */}
        </div>
    );
}